import React, { useEffect, useState } from "react";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { Modal } from "react-bootstrap";
import axios from "axios";
import "./PaidUsers.css";

function DirectPaidUsers({ adminType }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfUser, setnoOfUser] = useState(0);
  const [loader, setLoader] = useState(true);
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);
  const [reason, setReason] = useState("");
  const [stats, setStats] = useState({});

  const [selectedSubscription, setSelectedSubscription] = useState({});
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    setSelectedSubscription(data);
    setShow(true);
  };

  const getUsers = async () => {
    try {
      let payload = { page: page };
      setLoader(true);
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("token");
      const userData = await api.directsubsGet(payload);
      setData(userData.data);
      setnoOfUser(userData.count);
      setLimit(userData.limit);
      setStats(userData.stats);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  // const deleteSubscription = async (id) => {
  //   try {
  //     let payload = { id: id };
  //     setLoader(true);
  //     const userData = await api.SuperAdminDeleteSubs(payload);
  //     if (userData?.success) {
  //       alert("Subscription deleted");
  //       getUsers();
  //     }
  //     setLoader(false);
  //   } catch (error) {
  //     console.log(error);
  //     alert("Something went wrong");
  //     setLoader(false);
  //   }
  // };

  // const cancelSubcription = async () => {
  //   try {
  //     if (!reason) {
  //       alert("Please select reason");
  //       return;
  //     }
  //     setLoader(true);

  //     const payload = {
  //       id: selectedSubscription?._id,
  //       subscriptionId: selectedSubscription?.subscriptionId || "",
  //       reason: reason || "",
  //       userId: selectedSubscription?.user,
  //     };

  //     const resp = await api.SuperAdminCancelSubs(payload);
  //     setLoader(false);
  //     handleClose();
  //     if (resp?.res?.status == "canceled") {
  //       getUsers();
  //       alert("Now user subscription has canceled.");
  //     } else {
  //       alert("There is an issue for cancel, try later.");
  //     }
  //   } catch (error) {
  //     setLoader(false);
  //     console.log(error.message);
  //     handleClose();
  //     var err = error?.message || "";
  //     if (err.includes("No such subscription")) {
  //       alert("No such subscription");
  //     } else {
  //       alert(err);
  //     }
  //   }
  // };

  const handleSearch = async () => {
    try {
      if (searchMail) {
        let payload = { email: searchMail };
        const res = await api.searchTempSubs(payload);
        if (res?.success) {
          setData(res?.data || []);
          setLoader(false);
        } else {
          alert("User not found");
        }
      } else {
        alert("Please insert email for search");
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      alert(error?.message || "No data found");
    }
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  useEffect(() => {
    getUsers();
  }, [page, resetPage]);

  const handleReset = () => {
    setResetPage(!resetPage);
    setPage(1);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="paid-users-management-wrapper">
              {/* Header Section */}
              <div className="paid-users-header-section mb-5">
                <div className="paid-users-header-content">
                  <div className="paid-users-title-section">
                    <h1 className="paid-users-main-title">
                      <i className="fas fa-crown paid-users-title-icon me-3"></i>
                      Direct Paid Users
                    </h1>
                    <p className="paid-users-subtitle">
                      Manage and monitor premium subscription users and their
                      payment status
                    </p>
                  </div>

                  {/* Search and Reset Section */}
                  <div className="paid-users-search-section">
                    <div className="paid-users-search-container">
                      <div className="paid-users-search-input-wrapper">
                        <i className="fas fa-search paid-users-search-icon"></i>
                        <input
                          type="text"
                          className="paid-users-search-input"
                          placeholder="Search paid users by email address..."
                          value={searchMail}
                          onChange={(e) => setSearchMail(e.target.value)}
                          onKeyPress={(e) =>
                            e.key === "Enter" && handleSearch()
                          }
                        />
                        {searchMail && (
                          <button
                            className="paid-users-search-clear"
                            onClick={() => setSearchMail("")}
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        )}
                      </div>
                      <button
                        className="paid-users-search-btn"
                        onClick={handleSearch}
                      >
                        <i className="fas fa-magnifying-glass me-2"></i>
                        Search
                      </button>
                    </div>
                    <button
                      className="paid-users-reset-btn"
                      onClick={handleReset}
                    >
                      <i className="fas fa-arrows-rotate me-2"></i>
                      Reset
                    </button>
                  </div>
                </div>

                {/* Stats Cards */}
                <div className="paid-users-stats-container">
                  <div className="paid-users-stat-card">
                    <div className="paid-users-stat-icon total-paid-users">
                      <i className="fas fa-users"></i>
                    </div>
                    <div className="paid-users-stat-content">
                      <h3 className="paid-users-stat-number">{noOfUser}</h3>
                      <p className="paid-users-stat-label">
                        Total Subscriptions
                      </p>
                    </div>
                  </div>
                  <div className="paid-users-stat-card">
                    <div className="paid-users-stat-icon active-subscriptions">
                      <i className="fas fa-users"></i>
                    </div>
                    <div className="paid-users-stat-content">
                      <h3 className="paid-users-stat-number">
                        {stats?.todaySubscriptions || 0}
                      </h3>
                      <p className="paid-users-stat-label">
                        Today Subscriptions
                      </p>
                    </div>
                  </div>
                  <div className="paid-users-stat-card">
                    <div className="paid-users-stat-icon monthly-plans">
                      <i className="fas fa-users"></i>
                    </div>
                    <div className="paid-users-stat-content">
                      <h3 className="paid-users-stat-number">
                        {stats?.last7DaysSubscriptions || 0}
                      </h3>
                      <p className="paid-users-stat-label">
                        Last 7 days Subscriptions
                      </p>
                    </div>
                  </div>
                  <div className="paid-users-stat-card">
                    <div className="paid-users-stat-icon revenue-card">
                      <i className="fas fa-users"></i>
                    </div>
                    <div className="paid-users-stat-content">
                      <h3 className="paid-users-stat-number">
                        {stats?.monthSubscriptions || 0}
                      </h3>
                      <p className="paid-users-stat-label">
                        This Month Subscriptions
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Table Section */}
              <Table
                data={data}
                setPage={setPage}
                page={page}
                noOfUser={noOfUser}
                limit={limit}
                // deleteSubscription={deleteSubscription}
                adminType={adminType}
                handleShow={handleShow}
              />
            </div>
          </div>
        </div>
      </div>

      {loader && <Loader />}

      {/* Cancel Subscription Modal */}
      {/* <Modal
        show={show}
        onHide={handleClose}
        centered
        className="paid-users-modal"
      >
        <Modal.Body>
          <div className="paid-users-modal-content">
            <div className="paid-users-modal-header">
              <h5 className="paid-users-modal-title">
                <i className="fas fa-exclamation-triangle me-2 text-warning"></i>
                Cancel Subscription
              </h5>
              <button className="paid-users-modal-close" onClick={handleClose}>
                <i className="fas fa-times"></i>
              </button>
            </div>

            <div className="paid-users-modal-body">
              <h6 className="mb-4 text-center text-muted">
                Why are you canceling this user's subscription?
              </h6>

              <div className="paid-users-form-group mb-4">
                <div className="paid-users-select-wrapper">
                  <i className="fas fa-caret-down paid-users-arrow-icon"></i>
                  <select
                    name="reason"
                    className="paid-users-select"
                    onChange={(e) => setReason(e.target.value)}
                    value={reason}
                  >
                    <option value="">Select Reason</option>
                    <option value="admin">Admin Decision</option>
                    <option value="violation">Terms Violation</option>
                    <option value="request">User Request</option>
                    <option value="other">Other Reason</option>
                  </select>
                </div>
              </div>

              <div className="paid-users-subscription-info mb-4 p-3 bg-light rounded">
                <p className="mb-2">
                  <i className="fas fa-user me-2 text-primary"></i>
                  <strong>User:</strong>{" "}
                  {selectedSubscription?.userdata?.name ||
                    selectedSubscription?.name}
                </p>
                <p className="mb-2">
                  <i className="fas fa-envelope me-2 text-primary"></i>
                  <strong>Email:</strong>{" "}
                  {selectedSubscription?.userdata?.email ||
                    selectedSubscription?.email}
                </p>
                <p className="mb-0">
                  <i className="fas fa-calendar-times me-2 text-primary"></i>
                  <strong>Subscription Ends:</strong>{" "}
                  {selectedSubscription?.nextPayment
                    ? formatDate(selectedSubscription?.nextPayment)
                    : "N/A"}
                </p>
              </div>

              <div className="paid-users-warning-alert mb-4">
                <div className="alert alert-warning">
                  <i className="fas fa-exclamation-circle me-2"></i>
                  This action will cancel the user's subscription immediately.
                  They will lose access to premium features.
                </div>
              </div>

              <div className="paid-users-modal-footer">
                <button className="paid-users-cancel-btn" onClick={handleClose}>
                  <i className="fas fa-times me-2"></i>
                  Cancel
                </button>
                {loader ? (
                  <button className="paid-users-confirm-btn loading">
                    <i className="fas fa-spinner fa-spin me-2"></i>
                    Processing...
                  </button>
                ) : (
                  <button
                    className="paid-users-confirm-btn"
                    onClick={cancelSubcription}
                    disabled={!reason}
                  >
                    <i className="fas fa-check-circle me-2"></i>
                    Confirm Cancellation
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  );
}

const Table = ({
  data,
  page,
  setPage,
  noOfUser,
  limit,
  deleteSubscription,
  adminType,
  handleShow,
}) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  {/* <th scope="col" className="">
                    Name
                  </th> */}
                  <th scope="col" className="">
                    Email
                  </th>
                  <th scope="col" className="">
                    Type
                  </th>
                  <th scope="col" className="">
                    <div className="w-max-c">Last Paid</div>
                  </th>
                  <th scope="col" className="">
                    <div className="w-max-c">Subscription End</div>
                  </th>
                  <th scope="col" className="">
                    <div className="w-max-c">Is Signed Up</div>
                  </th>
                  {/* {adminType == "mackAdmin777" && (
                    <th scope="col" className="">
                      <div className="w-max-c">Actions</div>
                    </th>
                  )} */}
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    {/* <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {item?.userdata?.name || item?.name}
                      </div>
                    </td> */}
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.userdata?.email || item?.email}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        Monthly
                      </span>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.subscribedAt
                          ? formatDate(item?.subscribedAt)
                          : "-"}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.nextPayment
                          ? formatDate(item?.nextPayment)
                          : "-"}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.isProcessed ? "Yes" : "No"}
                      </div>
                    </td>
                    {/* {adminType == "mackAdmin777" && (
                      <td>
                        {item?.subscriptionId == "manual" ? (
                          <button className="makeSubBtn">Added by Admin</button>
                        ) : (
                          <button
                            className="makeSubBtn"
                            onClick={() => handleShow(item)}
                          >
                            Cancel Subscription from Stripe
                          </button>
                        )}
                        <button
                          className="makeSubBtn"
                          onClick={() => deleteSubscription(item?._id)}
                        >
                          Delete Subscription from DB
                        </button>
                      </td>
                    )} */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-center mt-4">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfUser / limit)}
                page={page}
                onChange={handleChange}
                color="primary"
                sx={{
                  "& .MuiPaginationItem-root.Mui-selected": {
                    backgroundColor: "#3b82f6",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#2563eb",
                    },
                  },
                  "& .MuiPaginationItem-root": {
                    "&:hover": {
                      backgroundColor: "#e0f2fe",
                      color: "#0369a1",
                    },
                  },
                }}
              />
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};

export default DirectPaidUsers;
